import { render, staticRenderFns } from "./ContentBanner.vue?vue&type=template&id=22ea8374&"
import script from "./ContentBanner.vue?vue&type=script&lang=ts&"
export * from "./ContentBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports